import React, { useEffect, useState } from "react";
import { PDFDocument } from "pdf-lib";
import mammoth from "mammoth";
import LoadingSpinner from "../helpers/loadingspinner";
import stringSimilarity from "string-similarity";
import Swal from "sweetalert2";
import * as pdfjsLib from "pdfjs-dist";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { AddBenchCandidatesProfile_BulkImportwithDocs, AddCandidateIntSchDet, GenerateContent, GetJobRoles, LoginAPIURL, siteURL } from "../apiconstants/constants";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { RegisterAPIURL } from "../apiconstants/constants";
import logo from "../assets/images/knackhire-new.png"
import { defaultguid } from "../apiconstants/constants";
import axios from "axios";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";

const AIResumeInsights = () => {
  const guid = localStorage.getItem("guid");
  const token = localStorage.getItem('jwtToken');
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
  return localStorage.getItem('guid') !== defaultguid && !!localStorage.getItem('jwtToken');
});

  const [resumeText, setResumeText] = useState([]);
  const [text,setText] = useState("")
  const [jobResponsibilities, setJobResponsibilities] = useState("");
  const [matchPercentage, setMatchPercentage] = useState(null);
   const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [matchReason, setMatchReason] = useState(null);
  const [extractedCertifications, setExtractedCertifications] = useState(null);
   const [extractedSkills, setExtractedSkills] = useState([]);
  const [extractedTextSkills, setExtractedTextSkills] = useState([]);
  const [previousJobResponsibilities, setPreviousJobResponsibilities] = useState("");  
  const [previousResult, setPreviousResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [isLogin, setIsLogin] = useState(guid == defaultguid ? true : false );
  const { register,  handleSubmit,control, formState: { errors, isSubmitting }} = useForm();
 const [selectedCards, setSelectedCards] = useState([])
 const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState(localStorage.getItem("countryCodes")|| "");

   const [step, setStep] = useState(1); // Step 1 (Form) or Step 2 (Candidates)
      const [duration,setDuration] = useState([
         {durationID:"5",durationValue:"5"},
         {durationID:"10",durationValue:"10"},
        //  {durationID:"15",durationValue:"15"},
        //  {durationID:"20",durationValue:"20"},
        //  {durationID:"25",durationValue:"25"},
        //  {durationID:"30",durationValue:"30"}
        ])
         const [questions,setQuestions] = useState([
           {questionID:"1",questionValue:"1"},
           {questionID:"2",questionValue:"2"},
           {questionID:"3",questionValue:"3"},
           {questionID:"4",questionValue:"4"},
           {questionID:"5",questionValue:"5"},
           {questionID:"6",questionValue:"6"},
           {questionID:"7",questionValue:"7"},
           {questionID:"8",questionValue:"8"},
           {questionID:"9",questionValue:"9"},
           {questionID:"10",questionValue:"10"}])
           const [formData, setFormData] = useState({
            startDate: "",
            endDate: "",
            questionCount: "",
            duration: "",
            isVideoRequired: Boolean,
            jobRoleID : ""
          });
          const [selectedJobRole, setSelectedJobRole] = useState("");
          const [showPassword, setShowPassword] = useState(false);
          const [loginemail, setLoginEmail] = useState( localStorage?.getItem("email") || "");
    const [jobRoles, setJobRoles] = useState([]);
const [isGapAnalysisChecked, setIsGapAnalysisChecked] = useState(false);
const [isNeedAdditionalPointsChecked, setIsNeedAdditionalPointsChecked] = useState(false);
const [isComparing, setIsComparing] = useState(false);
const [uploadedFiles, setUploadedFiles] = useState([]);

    useEffect(() => {
        fetchJobRoles(); 

    }, [isModalOpen,selectedCountry]);
  useEffect(() => {
    if(isGapAnalysisChecked){
  handleGapAnalysis();
    }
}, [isGapAnalysisChecked]);

useEffect(() => {
      if(isNeedAdditionalPointsChecked){
  handleNecessaryPoints();
      }
}, [isNeedAdditionalPointsChecked]);
    const jobRoleOptions = jobRoles.map(role => ({
      value: role.jobRoleId,
      label: role.jobRole
  }));
 
          const fetchJobRoles = async () => {
            try {
                const response = await axios.get(`${GetJobRoles.APIURL}?UserGuid=${defaultguid}&CountryID=${selectedCountry}`);
                setJobRoles(response.data);
            } catch (error) {
                console.error("Error fetching job roles", error);
            }
        };    
  
          const handleProceed = () => {
            if (!formData.startDate || !formData.endDate || !formData.questionCount || !formData.duration || !formData.jobRoleID) {
              Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'All fields are required',
                showConfirmButton: false,
                timer: 3000
            });
              return;
            }
            setStep(2); // Move to step 2
          };
         
  const handleFileUpload = async (event) => {  
    const email = localStorage.getItem("email");
    const token = localStorage.getItem('jwtToken');
        const selectedCountry = localStorage.getItem('countryCodes');
setSelectedCountry(selectedCountry);
    if(token == null){
      setShowModal(true);
      return;
    }
    else{
      setShowModal(false);
    }
    setLoginEmail(email)
    const files = Array.from(event.target.files);
    setUploadedFiles(files);
    if (!files || files.length === 0) {
      setResumeText([]);
      return;
    }
    setPreviousResult(null);
    setSelectedCards([]);
    setFormData({});
    setShowDetails(false);
    setLoading(true);
    setIsComparing(true);
    const allowedFormats = ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
    
    let extractedResumes = []; 

    for (const file of files) {
        if (!allowedFormats.includes(file.type)) {
            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Please upload only .pdf or .docx files',
                showConfirmButton: false,
                timer: 3000
            });
            continue; 
        }

        try {
            let extractedText = await extractTextFromFile(file);
            console.log(`Extracted Resume Text for ${file.name}:`, extractedText);
            const extractedDetails = await extractDetails(extractedText);
              extractedResumes.push({ fileName: file.name,
              resumeText: extractedText, ...extractedDetails });

        } catch (err) {
            setIsComparing(false);
            console.error(`Error extracting text from ${file.name}:`, err);
        }
    }

    console.log("Extracted Resumes:", extractedResumes);
    setLoading(false)
    setIsComparing(false)
    setResumeText(extractedResumes); 
};

console.log("resumeText",resumeText.resumeText)

const extractDetails = async (text) => {
    console.log("80", text);
    const token = localStorage.getItem('jwtToken');
    try {
        const response = await axios.post(
       GenerateContent.APIURL,
       {
        prompt: `Extract all certifications mentioned in this resume text. 
          Return only a comma-separated list of certifications without extra text:\n\n${text}`,
    },
    { headers: {
      'Content-Type': 'application/json',
      'accept': '*/*',
      'Authorization': `Bearer ${token}` // Add the Authorization header       
       }}

        );

        console.log("API Response:", response);

        const responseContent = response.data?.response?.candidates[0]?.content?.parts?.[0]?.text || "";
        const certMatches = responseContent?.split(",").map((cert) => cert.trim());
        const extractedSkills = await analyzeSkill(text);
        console.log("extractedSkills",extractedSkills)

        return {
            skills: extractedSkills.length > 0 ? extractedSkills : ["Not Found"],
            certifications: certMatches?.length > 0 ? certMatches : ["Not Found"],
        };
    } catch (err) {
         if (err.response && err.response.status === 401) {
                    Swal.fire({
                      position: 'center',
                      icon: 'error',
                      title: 'Session expired! Please Login again',
                      showConfirmButton: false,
                      timer: 5000,
                    }); 
                    setTimeout(() => {
                      setSessionExpired(true)
                      setShowModal(true );
                    }, 5000);
                    return;
                  }
        console.error("Error extracting certifications:", err);
        return {
            skills: ["Not Found"],
            certifications: ["Not Found"],
        };
    }
};

  const extractTextFromFile = async (file) => {
    if (file.type === "application/pdf") {
      return extractTextFromPDF(file);
    } else if (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
      return extractTextFromDOCX(file);
    } else {
      throw new Error("Unsupported file type. Please upload a PDF or DOCX.");
    }
  };

  const extractTextFromPDF = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    let extractedText = "";

    for (let i = 0; i < pdf.numPages; i++) {
        const page = await pdf.getPage(i + 1);
        const textContent = await page.getTextContent();
        extractedText += textContent.items.map(item => item.str).join(" ") + " ";
    }

    return extractedText;
};

  const extractTextFromDOCX = async (file) => {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onload = async (event) => {
        const arrayBuffer = event.target.result;
        mammoth
          .extractRawText({ arrayBuffer })
          .then((result) => resolve(result.value))
          .catch((err) => reject(err));
      };
      reader.readAsArrayBuffer(file);
    });
  };

  const handleClose = () => {
    setShowModal(false);
  };
  
  const onClose = () => {
    setIsModalOpen(false);
  };

  
  const handleSaveCandidates = async (apiemail, resume,selectedCountry) => {
    let data = resume || resumeText;
  
    const formattedData = data.map((item) => ({
      userGuid: defaultguid,
      fullName: item?.name,
      email: item?.email, // Ensure correct email
      mobileNumber: item.mobileNumber?.toString(),
      dob: null,
      gender: "male",
      address: item.address,
      jobRole: formData?.jobRoleID || 5,
      maritalStatus: "unmarried",
      technicalSkill: item.skills?.join(", "),
      experience: item.experience,
      preferLocation: item.Country,
      workMode: item.workMode,
      profileSummery: item.profilesummary,
      billRate: item.billRate,
      payRate: item.payRate,
      workAuthorizationandValidity: item.workAuthorizationandValidity,
      employerName: item.employerName,
      ssn: item.ssn?.toString(),
      passportNo: item.passportNo,
      tworefrencesfromrecentproject: item.tworefrencesfromrecentproject,
      linkedInUrl: item.linkedin,
      certifications: item.certifications?.join(", "),
      createdBy: apiemail,
      countryID:selectedCountry
    }));
  const formDataToSend = new FormData();

formDataToSend.append("CandidatesJson", JSON.stringify(formattedData)); // JSON data
console.log("324",uploadedFiles)
uploadedFiles.forEach((file) => {
  formDataToSend.append("ResumeFiles", file, file.name); // ✅ Add each file
});
    try {
      const response = await axios.post(
        AddBenchCandidatesProfile_BulkImportwithDocs.APIURL,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      const apiData = response.data.candidates; // Ensure candidates exist
      console.log("API Data:", apiData, "API Email:", apiemail);
  
      if (!Array.isArray(apiData) || apiData.length === 0) {
        console.error("API returned no candidates!");
        return;
      }
  
      // Normalize apiemail and user emails before matching
      const cleanApiEmail = apiemail?.trim().toLowerCase();
      console.log("Cleaned API Email:", cleanApiEmail);
      
      setResumeText((prev) =>
        prev.map((item) => {
          const userData = apiData.find(user => user.email == item?.email);

  
          console.log("Matching User Data:", userData);
  
          return {
            ...item,
            userGuid: userData?.userGuid || defaultguid,
            candidateID: userData?.candidateID || null,
          };
        })
      );
    } catch (error) {
      console.error("Error saving candidates:", error);
    }
  };
  
 
  const analyzeResumesAndCertifications = async () => {
    setIsLoading(true);
    if (!resumeText || resumeText.length === 0 || !jobResponsibilities ) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please upload at least one resume and job responsibilities.',
        showConfirmButton: false,
        timer: 3000
    });
      setIsLoading(false);

      return;
    }
      try {
      const jobskillsResults = await analyzetextareaSkill();
      console.log("201",jobskillsResults)
      const results = await updateMatchedSkills(jobskillsResults);
      const resumeResults = await analyzeResume();
      console.log("202",resumeResults)
        const certificationResults = await analyzeCertifications();
        console.log("resumeresult",resumeResults,certificationResults)
        console.log("resumeee",resumeText)
       setResumeText((prev) =>
        prev.map((resume, index) => ({
          ...resume,
          ...results,
          matchJobResponsibilitiesPercentage: resumeResults[index]?.matchPercentage || "N/A",
          reasons: resumeResults[index]?.reasons || ["No reason provided."],
          matchedCertificationswithJobResponsibilities:
            certificationResults[index]?.matchedCertifications || ["No matched certifications found"],
        }))
        
      );

      setShowDetails(guid == defaultguid ? true : false );
      setShowModal(guid == defaultguid ? false : true );
      const email = localStorage.getItem("email")
      const selectedcountry = localStorage.getItem("countryCodes")
      setLoginEmail(email);
      console.log("hiii",email)
      if(email != null){
     await handleSaveCandidates(email,results,selectedcountry);
      }
   
    } catch (error) {
      console.error("Error analyzing resumes and certifications:", error);
    }finally {
      setIsLoading(false);
    }
  };
  console.log("resumeee11",resumeText)

  const analyzeResume = async () => {
    const token = localStorage.getItem('jwtToken');
    if (!resumeText || resumeText.length === 0 || !jobResponsibilities) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please upload at least one resume and job description.',
        showConfirmButton: false,
        timer: 3000
      });
      return null;
    }
  
    try {
        // Create an array of promises to process each resume in parallel
      const requests = resumeText.map(async (resume, index) => {
        const response = await axios.post(
          GenerateContent.APIURL,
          {
              prompt: `You are an expert resume analysis engine.

              Analyze the following **Resume** and **Job Description**, and provide **6 to 7 bullet points** (as a JSON array of strings) that summarize the **key strengths, relevant certifications or learning efforts**, and **gaps in skills or responsibilities** based on the comparison.
              
              ### Guidelines:
              - Focus on specific technical responsibilities or certifications that align with the job description.
              - Include any learning effort or familiarity that could be considered positive, even if there's no formal experience.
              - Highlight any clear skill or experience gaps relevant to the job.
              - Do not include generic statements like "good fit" or "not suitable".
              - Each point must be concise and technically specific.
              - Return **only a valid JSON array of strings**. No markdown or extra explanation.
              
              ### Resume:
              ${resume.resumeText}
              
              ### Job Description:
              ${jobResponsibilities}
              
              ### Output Format:
              [
                "Point 1",
                "Point 2",
                "Point 3",
                "Point 4",
                "Point 5",
                "Point 6",
                "Point 7"
              ]`
          },
          { headers: {
            'Content-Type': 'application/json',
            'accept': '*/*',
            'Authorization': `Bearer ${token}` // Add the Authorization header       
             }}
    
      );
      console.log(`📄 Response for Resume ${index + 1}:`, response);

      const rawText = response.data?.response?.candidates[0]?.content?.parts?.[0]?.text || "";
        const cleaned = rawText.replace(/```json\s*|```/g, "").trim();
  
        try {
          const parsed = JSON.parse(cleaned);
          return { resumeIndex: index + 1, reasons: parsed };
        } catch (err) {
          console.error(`❌ Failed to parse insight response for Resume ${index + 1}:`, rawText);
          return { resumeIndex: index + 1, reasons: ["Error parsing response."] };
        }
      });
  
      // Execute all API requests in parallel
      const results = await Promise.all(requests);
      console.log("✅ Final Insights for All Resumes:", results);
  
      return results; // ✅ Return structured insights for all resumes
  
    } catch (error) {
         if (error.response && error.response.status === 401) {
                    Swal.fire({
                      position: 'center',
                      icon: 'error',
                      title: 'Session expired! Please Login again',
                      showConfirmButton: false,
                      timer: 5000,
                    }); 
                    setTimeout(() => {
                      setSessionExpired(true)
                      setShowModal(true );
                    }, 5000);
                    return;
                  }
      console.error("❌ Error analyzing resumes:", error);
      return null;
    }
  };
  
  
    const analyzeCertifications = async () => { 
      const token = localStorage.getItem('jwtToken');
      if (!jobResponsibilities || !resumeText || resumeText.length === 0) {
        setError("Please upload a resume and enter job responsibilities.");
        return;
      }
    
      try {
        let allMatchedCertifications = [];
    
        for (let i = 0; i < resumeText.length; i++) {
          const currentResume = resumeText[i]; // Process each resume separately
          console.log("currentresume",currentResume)
          const response = await axios.post(
            GenerateContent.APIURL,
            {
                prompt: `### **Task:**  
                  1️⃣ Extract only explicit certifications from the resume content.
                  2️⃣ Extract only explicit required certifications from the job responsibilities.
                  3️⃣ Compare both lists and return only exact matches (no semantic similarity checks).
                  
                  🔍 Important:
                  
                  Do not infer or assume certifications based on general skills.
                  If no exact certification names match, return: No matched certifications found.
                  #### **Resume Content:**  
                  ${currentResume.resumeText}  
                  
                  #### **Job Responsibilities:**  
                  ${jobResponsibilities}  
                  
                  ### **Response Format:**  
                  **Matched Certifications:**  
                  - Certification 1  
                  - Certification 2`
            },
            { headers: {
              'Content-Type': 'application/json',
              'accept': '*/*',
              'Authorization': `Bearer ${token}` // Add the Authorization header       
               }}
      
        );

        console.log(`API Response for Candidate ${i + 1}:`, response);

        const responseContent = response.data?.response?.candidates[0]?.content?.parts?.[0]?.text || "";
        console.log(`Extracted Response Content for Candidate ${i + 1}:`, responseContent);


          console.log(`Extracted Response Content for Candidate ${i + 1}:`, responseContent);
              const matchedCertificationsMatch = responseContent.match(/(?<=\*\*Matched Certifications:\*\*\n)([\s\S]*?)(?=\n\n|$)/);
      const matchedCertifications = matchedCertificationsMatch 
        ? matchedCertificationsMatch[1]
            .split("\n")
            .filter((line) => line.startsWith("- ")) 
            .map((cert) => cert.replace("- ", "").trim()) 
        : [];

      const finalCertifications = matchedCertifications.length > 0 
        ? matchedCertifications 
        : ["No matched certifications found"];

      allMatchedCertifications.push({
        resumeIndex: i + 1,
        matchedCertifications: finalCertifications,
      });
    }   setExtractedCertifications(allMatchedCertifications); // Store results for all candidates
        return allMatchedCertifications;
    
      } catch (err) {
        if (err.response && err.response.status === 401) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Session expired! Please Login again',
            showConfirmButton: false,
            timer: 5000,
          }); 
          setTimeout(() => {
            setSessionExpired(true)
            setShowModal(true );
          }, 5000);
          return;
        }
        console.error("Error calling AI API:", err);
      }
    };

  const analyzeSkill = async (resumeText) => {
    if (!resumeText) {
      setError("Please upload a resume.");
      return;
    }
    const token = localStorage.getItem('jwtToken');
    try {
          const response = await axios.post(
        GenerateContent.APIURL,
        {
            prompt:`Extract all skills from the following text. Follow these guidelines:

                    1. *Extract All Skills:*  
                      - Extract all skills explicitly listed under the "Skills" or "Technical Skills" section.  
                      - Also extract any additional skills mentioned under other sections such as experience, projects, certifications, education, or achievements.  
                      - Capture programming languages, frameworks, tools, platforms, DevOps tools, business skills, and industry-specific skills.  

                    2. *Hidden and Embedded Skills:*  
                      - If a skill is mentioned within a sentence or as part of a project description, extract it.  
                      - Example: "Worked on Docker for containerization" → Extract *Docker* as a skill.  

                    3. *Normalization:*  
                      - If the skill is mentioned under a different name or alias, normalize it to the standard term (e.g., “Azure Databricks” → “Databricks”, “Microsoft Azure” → “Azure”).  

                    4. *DevOps and Monitoring Tools:*  
                      - Ensure DevOps tools like *Jenkins*, *Terraform*, *Docker*, *CI/CD*, and monitoring tools like *Grafana* and *Prometheus* are included if present.  

                    5. *Format Output:*  
                      - Return a single, comma-separated list of all extracted skills (including both explicitly listed and inferred skills).  
                      - Remove duplicates and ensure consistent formatting.  

                    6. *Retry and Match:*  
                      - If the skills section is missing or unclear, attempt to extract skills from other sections or provide the closest possible match.  
                      - If you suspect that some skills were not captured, retry extraction automatically.  

                    7. *Exclude:*  
                      - Exclude soft skills (e.g., communication, leadership, problem-solving).  
                      - Exclude job responsibilities and achievements.  
                      - Exclude processes (e.g., Agile, Performance Tuning, Cost Optimization).  

                    ### Examples of Expected Skills:
                    - Programming: Python, Java, C++, SQL  
                    - Platforms: AWS, Azure, GCP, Kubernetes  
                    - DevOps: Jenkins, Docker, Terraform, Grafana  
                    - Data Tools: Spark, Hive, Snowflake, Databricks  
                    - Industry Skills: Financial Analysis, Healthcare Compliance 
### Resume:
${resumeText}`,
        },
        { headers: {
          'Content-Type': 'application/json',
          'accept': '*/*',
          'Authorization': `Bearer ${token}` // Add the Authorization header       
           }}
  
    );

    console.log("API Response:", response);

    const responseContent = response.data?.response?.candidates[0]?.content?.parts?.[0]?.text || "";
   
      const extractedSkills = responseContent.split(",").map((skill) => skill.trim());
      setExtractedSkills(extractedSkills);
      return extractedSkills;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Session expired! Please Login again',
          showConfirmButton: false,
          timer: 5000,
        }); 
        setTimeout(() => {
          setSessionExpired(true)
          setShowModal(true );
        }, 5000);
        return;
      }
      console.error("Error extracting skills:", err);
      setError("Failed to extract skills.");
    }
  };

  const analyzetextareaSkill = async () => {
    if (!jobResponsibilities) {
      setError("Please enter key skills in the text area.");
      return;
    }
    const token = localStorage.getItem('jwtToken');
    try {
      const response = await axios.post(
      GenerateContent.APIURL,
        {
            prompt: `Extract all skills from the following text. Follow these guidelines:

                    1. *Extract All Skills:*  
                      - Extract all skills explicitly listed under the "Skills" or "Technical Skills" section.  
                      - Also extract any additional skills mentioned under other sections such as experience, projects, certifications, education, or achievements.  
                      - Capture programming languages, frameworks, tools, platforms, DevOps tools, business skills, and industry-specific skills.  

                    2. *Hidden and Embedded Skills:*  
                      - If a skill is mentioned within a sentence or as part of a project description, extract it.  
                      - Example: "Worked on Docker for containerization" → Extract *Docker* as a skill.  

                    3. *Normalization:*  
                      - If the skill is mentioned under a different name or alias, normalize it to the standard term (e.g., “Azure Databricks” → “Databricks”, “Microsoft Azure” → “Azure”).  

                    4. *DevOps and Monitoring Tools:*  
                      - Ensure DevOps tools like *Jenkins*, *Terraform*, *Docker*, *CI/CD*, and monitoring tools like *Grafana* and *Prometheus* are included if present.  

                    5. *Format Output:*  
                      - Return a single, comma-separated list of all extracted skills (including both explicitly listed and inferred skills).  
                      - Remove duplicates and ensure consistent formatting.  

                    6. *Retry and Match:*  
                      - If the skills section is missing or unclear, attempt to extract skills from other sections or provide the closest possible match.  
                      - If you suspect that some skills were not captured, retry extraction automatically.  

                    7. *Exclude:*  
                      - Exclude soft skills (e.g., communication, leadership, problem-solving).  
                      - Exclude job responsibilities and achievements.  
                      - Exclude processes (e.g., Agile, Performance Tuning, Cost Optimization).  

                    ### Examples of Expected Skills:
                    - Programming: Python, Java, C++, SQL  
                    - Platforms: AWS, Azure, GCP, Kubernetes  
                    - DevOps: Jenkins, Docker, Terraform, Grafana  
                    - Data Tools: Spark, Hive, Snowflake, Databricks  
                    - Industry Skills: Financial Analysis, Healthcare Compliance 
                    
                    text:
                    ${jobResponsibilities}`,
        },
        { headers: {
          'Content-Type': 'application/json',
          'accept': '*/*',
          'Authorization': `Bearer ${token}` // Add the Authorization header       
           }}
  
    );

    console.log("API Response:", response);

    const responseContent = response.data?.response?.candidates[0]?.content?.parts?.[0]?.text || "";
   
    const  extractedTextSkills = (responseContent.split(",").map((skill) => skill.trim()));
    setExtractedTextSkills(extractedTextSkills)
      return extractedTextSkills
    } catch (err) {
      if (err.response && err.response.status === 401) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Session expired! Please Login again',
          showConfirmButton: false,
          timer: 5000,
        }); 
        setTimeout(() => {
          setSessionExpired(true)
          setShowModal(true );
        }, 5000);
        return;
      }
      console.error("Error extracting skills:", err);
      setError("Failed to extract skills.");
    }
  };
const handleGapAnalysis = async () => {
  if (!resumeText || resumeText.length === 0) {
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'Please upload at least one resume.',
      showConfirmButton: false,
      timer: 3000
    });
    return null;
  }
setIsComparing(true);
  try {
    const requests = resumeText.map(async (resume, index) => {
      const response = await axios.post(
        GenerateContent.APIURL,
        {
          prompt: `You are a professional resume evaluator.

Analyze the following **Resume** and identify any **career time gaps** — unexplained breaks or missing employment periods of 6 months or more in the candidate's career timeline.

### Guidelines:
- Focus only on **time gaps** in employment history.
- Detect if there are **large breaks** (6+ months) between jobs.
- Mention if the resume lacks **recent experience** (e.g., no job listed after 2021).
- Do not analyze technical skills, certifications, or compare with a job description.
- Output must be a valid **JSON array of strings only**.
- Do not include markdown, summaries, or additional explanation.

### Resume:
${resume.resumeText}

### Output Format:
[
  "Gap 1",
  "Gap 2",
  "Gap 3"
]
`
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'accept': '*/*',
            'Authorization': `Bearer ${token}`
          }
        }
      );

      const rawText = response.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text || "";
      const cleaned = rawText.replace(/```json\s*|```/g, "").trim();

      try {
        const parsed = JSON.parse(cleaned);
        setIsComparing(false);
        return { index, timeGaps: parsed };
      } catch (err) {
       setIsComparing(false);
        console.error(`❌ Failed to parse time gap response for Resume ${index + 1}:`, rawText);
        return { index, timeGaps: ["Error parsing response."] };
      }
    });

    const results = await Promise.all(requests);

    // ✅ Set in resumeText
    setResumeText((prev) =>
      prev.map((resume, index) => {
        const found = results.find((r) => r.index === index);
        return { ...resume, timeGaps: found?.timeGaps || [] };
      })
    );

    return results;

  } catch (err) {
         setIsComparing(false);
    if (err.response?.status === 401) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Session expired! Please Login again',
        showConfirmButton: false,
        timer: 5000,
      });
      setTimeout(() => {
        window.location.href = "/Login";
      }, 5000);
      return;
    }
    console.error("❌ Error analyzing resumes:", err);
    return null;
  }
};

const handleNecessaryPoints = async () => {
  if (!resumeText || resumeText.length === 0 || !jobResponsibilities) {
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'Please upload at least one resume and job description.',
      showConfirmButton: false,
      timer: 3000
    });
    return null;
  }
        setIsComparing(true);

  try {
    const requests = resumeText.map(async (resume, index) => {
      const response = await axios.post(
        GenerateContent.APIURL,
        {
          prompt: `You are a professional resume evaluator.

Analyze the following **Resume** and **Job Description**, and provide **5 necessary points** that the candidate should add or improve in their resume to better align with the job description.

### Guidelines:
- These should include **missing or underemphasized points** critical for the role.
- Focus on technical skills, tools, certifications, project experiences, or responsibilities.
- Be actionable and resume-focused — what exactly to add or enhance.
- Output must be a valid **JSON array of exactly 5 strings**.
- No markdown or extra explanation.

### Resume:
${resume.resumeText}

### Job Description:
${jobResponsibilities}

### Output Format:
[
  "Necessary Point 1",
  "Necessary Point 2",
  "Necessary Point 3",
  "Necessary Point 4",
  "Necessary Point 5"
]
`
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'accept': '*/*',
            'Authorization': `Bearer ${token}`
          }
        }
      );

      const rawText = response.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text || "";
      const cleaned = rawText.replace(/```json\s*|```/g, "").trim();

      try {
        const parsed = JSON.parse(cleaned);
       setIsComparing(false);
        return { index, necessaryImprovements: parsed };
      } catch (err) {
        console.error(`❌ Failed to parse improvement points for Resume ${index + 1}:`, rawText);
        return { index, necessaryImprovements: ["Error parsing response."] };
      }
    });

    const results = await Promise.all(requests);

    // ✅ Set in resumeText
    setResumeText((prev) =>
      prev.map((resume, index) => {
        const found = results.find((r) => r.index === index);
        return { ...resume, necessaryImprovements: found?.necessaryImprovements || [] };
      })
    );

    return results;

  } catch (err) {
         setIsComparing(false);
    if (err.response?.status === 401) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Session expired! Please Login again',
        showConfirmButton: false,
        timer: 5000,
      });
      setTimeout(() => {
        window.location.href = "/Login";
      }, 5000);
      return;
    }
    console.error("❌ Error analyzing resumes:", err);
    return null;
  }
};
  const analyzeResumeWithJD = async (resumeText, jobResponsibilities) => { 
    if (!resumeText || !jobResponsibilities) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please upload a resume and job responsibilities.',
        showConfirmButton: false,
        timer: 3000
      });
      return null;
    }
  
    if (jobResponsibilities === previousJobResponsibilities && previousResult !== null) {
      console.log("Using cached result:", previousResult);
      setMatchPercentage(previousResult);
      return previousResult;
    }
    const token = localStorage.getItem('jwtToken');
    try {
      const response = await axios.post(
        GenerateContent.APIURL,
        {
            prompt: `You are an expert resume analysis engine.
  
  Compare the following **Resume** and **Job Description**, and return a JSON object with exactly the following fields only:
  
  1. **name**: Full name extracted from the resume.
  2. **email**: Email address from the resume.
  3. **phoneNumber**: Phone number from the resume.
  4. **matchedSkills**: A list of *technical skills* found in both the resume and the job description.
  5. **unmatchedSkills**: A list of *key technical skills* present in the job description but NOT found anywhere in the resume.
  6. **totalJDskills**: The total number of unique skills extracted from the job description.
   7. **profilesummary**: The candidate's profile summary or professional overview as written in the resume.
8. **experience**: Calculate total professional experience using all employment periods listed in the resume. For any job with an end date marked as "Present", "Till Date", or similar, use today's date (assume current date is June 16, 2025) as the end date. The result should be formatted as "X years Y months", and must be accurate.
9. **address**: Physical address or location mentioned in the resume.
10. **linkedin**: LinkedIn profile URL if mentioned in the resume. 

  ### Resume:
  ${resumeText}
  
  ### Job Description:
  ${jobResponsibilities}
  
  ### Output Format (JSON Only):
  {
    "name": "Full Name",
    "email": "example@email.com",
    "phoneNumber": "1234567890",
    "matchedSkills": ["Skill1", "Skill2"],
    "unmatchedSkills": ["SkillA", "SkillB"],
    "totalJDskills": 10,
        "profilesummary": "Candidate's summary goes here...",
  "experience": "3 years 2 months",
  "address": "City, State, Country",
  "linkedin": "https://linkedin.com/in/username"
  }`,
        },
        { headers: {
          'Content-Type': 'application/json',
          'accept': '*/*',
          'Authorization': `Bearer ${token}` // Add the Authorization header       
           }}
  
    
    );

    console.log("API Response:", response);

    // Extract response content
    const responseText = response.data?.response?.candidates[0]?.content?.parts?.[0]?.text || "";
   
      console.log("Extracted Text:", responseText);
  
      // Clean up markdown backticks before parsing
      const sanitizeJsonResponse = (text) => {
        return text.replace(/```json\s*|```/g, "").trim();
      };
  
      try {
        const cleanedJson = sanitizeJsonResponse(responseText);
        const parsedJson = JSON.parse(cleanedJson);
  
        // Calculate Matched Skills Percentage
        const matchedSkillsCount = parsedJson.matchedSkills?.length || 0;
        const totalJDskills = parsedJson.totalJDskills || (matchedSkillsCount + (parsedJson.unmatchedSkills?.length || 0));
        // const matchedSkillsPercentage = totalJDskills > 0 ? ((matchedSkillsCount / totalJDskills) * 100).toFixed(2) : "0.00";
  let matchedSkillsPercentage = totalJDskills > 0 
  ? ((matchedSkillsCount / totalJDskills) * 100) 
  : 0;

if (matchedSkillsPercentage > 100) {
  matchedSkillsPercentage = 100;
}

matchedSkillsPercentage = matchedSkillsPercentage.toFixed(2);
        const result = {
          name: parsedJson.name || "N/A",
          email: parsedJson.email || "N/A",
          phoneNumber: parsedJson.phoneNumber || "N/A",
          matchedSkills: parsedJson.matchedSkills || [],
          unmatchedSkills: parsedJson.unmatchedSkills || [],
          matchedSkillsPercentage: matchedSkillsPercentage,
               profilesummary: parsedJson.profilesummary || "N/A",
          experience: parsedJson.experience || "N/A",
          address: parsedJson.address || "N/A",
          linkedin: parsedJson.linkedin || "N/A"
        };
  
        setMatchReason(result);
        setPreviousJobResponsibilities(jobResponsibilities);
        setPreviousResult(result);
        setMatchPercentage(result);
  
        console.log("Processed Result:", result);
        return result; // ✅ Returning full AI response
  
      } catch (jsonError) {
        console.error("Error parsing JSON response:", jsonError);
        return {
          error: "Failed to parse AI response",
          rawResponse: responseText
        };
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Session expired! Please Login again',
          showConfirmButton: false,
          timer: 5000,
        }); 
        setTimeout(() => {
          setSessionExpired(true)
          setShowModal(true );
        }, 5000);
        return;
      }
      console.error("Error calling AI API:", err);
      return null;
    }
  };
  

  const updateMatchedSkills = async (jobSkills) => { 
    // Use Promise.all to resolve all async calculations
    const updatedResumes = await Promise.all(
        resumeText.map(async (resume) => {
            const { name, email, phoneNumber, matchedSkills, unmatchedSkills, matchedSkillsPercentage,  profilesummary, address, experience,linkedin } = 
                await analyzeResumeWithJD(resume.resumeText, jobSkills); // Changed to jobSkills

            return { 
                ...resume,
                name, 
                email, 
                phoneNumber, 
                matchedSkills, 
                unmatchedSkills, 
                matchedSkillsPercentage,
                profilesummary,
                address,
                experience,
                linkedin
            };
        })
    );

    console.log("Updated Resumes:", updatedResumes);
    setResumeText(updatedResumes);
    return updatedResumes; // Return the updated resumes instead of setting state
};


  // Login API call
  const handleLogin = async (data) => {
  
    setIsLoading(true)
    
    const filterData = {
      email: data.email,
      password: data.password,
      guid: defaultguid,
      roleID: 6,
    };
console.log(" 1139 login data: ", filterData);
    try {
      const result = await axios.post(LoginAPIURL.APIURL, filterData);
      console.log("Login Successful:", result.data);
      setIsLoading(false)
      if (result.data.message == "Success" && result.data.roleID == 6) {
      localStorage.setItem('guid', defaultguid);
      localStorage.setItem('email', result.data.email)
      localStorage.setItem('jwtToken', result.data.jwtToken)
      const loginCountry = localStorage.setItem('countryCodes', result.data.countryMappings)
        setSelectedCountry(loginCountry);
        setShowModal(false);
        setIsLoggedIn(true);

        // setShowDetails(true)
        if(sessionExpired == false && resumeText.length >0){
        await handleSaveCandidates(result.data.email,resumeText);
        }
      }
       else if(result.data.message==="Email or password is incorrect") {
                Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: 'Invalid User Name or Password, Please check your Email if you have not verified your email.',
                  showConfirmButton: false,
                  timer: 5000
                })
              }
         
              setIsLoading(false);
    } catch (error) {
      console.error("Login Failed:", error);
    }
  };

  const handleRegister = async (data) => {
    setIsLoading(true);
    
          console.log("Formdata",data.CountryMappings?.value)

    try {
      const formData = new FormData();
      formData.append("email", data.email);
      formData.append("FirstName", data.FirstName);
      formData.append("password", data.password);
      formData.append("employeeGuid", defaultguid);
      formData.append("roleID", 6);
      formData.append("CompanyName", "KnackHire");
      formData.append("CountryMappings", data.CountryMappings?.value);
      formData.append('Usertype', null);

      console.log("Formdata",formData)
        const result = await axios.post(RegisterAPIURL.APIURL, formData);
      if (result.data.message === "Success") {
        setIsLoading(false);
        Swal.fire({
          icon: "success",
          title: "Registration successful! Check your email for verification.",
          showConfirmButton: false,
          timer: 5000,
        });
        setShowModal(false);
        // setShowDetails(true)
      } else if (result.data.message === "already registered") {
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Email Already Registered. Please Log In if you have already verified your mail.",
          showConfirmButton: false,
          timer: 5000,
        });
        setShowDetails(false);
      }
    } catch (error) {
      console.error("Sign Up Failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitTest = (resume) => {
    setSelectedCards([resume])

    setIsModalOpen(true);
    setStep(1);
  };
 const handleConfigureTest = ( ) =>{
  setIsLoading(true);
  const loginemail = localStorage.getItem("email");
   const candidateData = selectedCards.map((person) => ({
   employerGuid: guid,
   email: person.email,
   candidatesID:person.candidateID,
   jobRoleID: formData.jobRoleID,
   testTypeID: 4,
   startDate: formData?.startDate, // Convert to ISO string format
   endDate: formData?.endDate,    // Convert to ISO string format
   time: formData?.duration,
   questionsCount:formData?.questionCount,
   CreatedBy: loginemail,
   jobDescription : jobResponsibilities,
   isVideoRequired: formData?.isVideoRequired,
   iscustomQuestionsRequired: false
}));
   
const apiUrl = AddCandidateIntSchDet.APIURL;
 axios.post(apiUrl, candidateData)
   .then((result) => {
      setIsLoading(false)

     if (result.data.message[0] === 'Job seekers added successfully') {
       Swal.fire({
         position: 'center',
         icon: 'success',
         title: 'Configured Test Successfully ',
         showConfirmButton: false,
         timer: 5000
       })
      }
      else if (result.data.message[0] == 'The test is already scheduled') {
        // GetConsultantProfile();
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'test is already scheduled',
          showConfirmButton: false,
          timer: 5000
        })
      }
        else if (result.data.message[0] == 'Updated successfully') {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'You have already configured test before so updated successfully',
            showConfirmButton: false,
            timer: 5000
          })
      }
      else if (result.data[0] == 'This user has already attempted the test. If you want to retake it, please reattempt the test.') {
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Candidate has already attempted the test',
          showConfirmButton: false,
          timer: 5000
        })
    }
      setIsModalOpen(false);
      setSelectedCards([]);
      setStep(1);
      setFormData({});
 })
 }
 const handleRemoveCandidate = (candidateID) => {
  setSelectedCards((prev) => prev.filter((candidate) => candidate.candidateID !== candidateID));
  setFormData({});
};
  return (
  <div className="container">

  <div className="row mt-5 ">
    <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
  <a
        class="btn btn-link btn-floating btn-lg text-white"
        href="https://knackhire.azurewebsites.net/" target="blank"
        role="button"
        data-mdb-ripple-color="dark"
        ><img src={logo} height={50} alt="Logo"/></a> </div>   
          <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
     
          
        <ul style={{ listStyle: "none", display: "flex", color: "#00a7ac", float: "right"}}>
  {isLoggedIn ? (
    <li
      onClick={() => {
        localStorage.clear();
        setIsLoggedIn(false); // ✅ This triggers rerender
        window.location.reload(); // optional: reload if you want to reset more
      }}
      style={{
        color: "#00a7ac",
        fontSize: "20px",
        marginRight: "30px",
        fontWeight: 800,
        cursor: "pointer",
      }}
    >
      Logout
    </li>
  ) : (
    <Link
      to="#"
      onClick={(e) => {
        e.preventDefault();
        setShowModal(true);
      }}
    >
      <li
        style={{
          color: "#00a7ac",
          fontSize: "20px",
          marginRight: "30px",
          fontWeight: 800,
          cursor: "pointer",
        }}
      >
        Login
      </li>
    </Link>
  )}


 
          <Link to ="/HowitWorks">
            <li style={{color:"#00a7ac",fontSize:'20px',marginRight:'30px',fontWeight:800}}>How it works</li> 
            </Link>
          <Link to ="/ContactUS"> 
           <li style={{color:"#00a7ac",fontSize:'20px',fontWeight:800}}>Contact</li>
           </Link>
          </ul>


</div>
</div>

<div className="text-center" style={{margin:'auto'}}>
<h2 style={{ fontSize: '25px', fontWeight: 'bold', marginBottom: '20px', paddingBottom: '10px',   position: 'relative',  color: '#00a7ac',
    borderBottom: '2px solid #00a7ac',  // Add the small border here
    display: 'inline-block',  // Makes the heading width smaller
    width: '200px',  // You can set a fixed width or adjust it as needed
    textAlign: 'center'  // Centers the text
  }}>
    AI Resume 
    Insights
</h2>
</div>
{isLoading ? (
  <div style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh", // Ensures it takes full screen height
    width: "100%",
  }}>
    <LoadingSpinner />
  </div>
) : (
  <>
 <h5 style={{ color: "#00a7ac" }}>Upload Resumes</h5>
  <input  className="form-control"
 type="file" accept=".pdf, .docx" multiple onChange={handleFileUpload} style={{ marginBottom: "10px", height:'38px' }} />
  <div className="form-group" style={{ width: '100%' }}>
      <label style={{color:"#00a7ac"}}>Job Role</label>
      <Controller 
       
      name="jobRoleID"
      control={control}
     // rules={{ required: "Job Role is required" }}
      render={({ field }) => (
        <Select
          {...field}
         
           placeholder="Select Job Role"
          options={jobRoleOptions}
          value={jobRoleOptions.find(option => option.value === formData.jobRoleID) || null} 
         onChange={(selectedOption) => {
        setFormData({ ...formData, jobRoleID: selectedOption?.value }); // Corrected onChange
        field.onChange(selectedOption); // Updates react-hook-form
      }}        
        className={` ${errors.JobRole ? 'is-invalid' : ''}`}
          styles={{
            control: (provided, state) => ({
              ...provided,
              height: 38,
            width:'100%',
             borderRadius:10,
             fontSize:15,
              borderColor: errors.JobRole ? 'red' : provided.borderColor
            }),
            menu: (provided) => ({
              ...provided,
              zIndex: 9999, // Ensures dropdown appears above everything
              position: "absolute" // Fixes layout issues
            })
          }}
        />
      )}
    />
  </div> 


 {loading ? <p>Processing Resumes... Please wait.</p> :
    <div style={{ width: "100%", gap: "20px", marginTop: "10px" }}>
        <h5 style={{color:"#00a7ac"}}>Job Description and Skillset</h5>

      <textarea
        placeholder="Enter Job Description and Skillset Details"
        value={jobResponsibilities}
        className="form-control basic-form"
        onChange={(e) => setJobResponsibilities(e.target.value)}
        style={{ width: "100%", height: "200px", padding: "10px",fontSize:'15px' }}
      />
    </div>
    }

       <div className="mt-3">
  <label>
    <input
      type="checkbox"
      className="mr-3"      
      checked={isGapAnalysisChecked}
      onChange={(e) => setIsGapAnalysisChecked(e.target.checked)}
    />
   Career gap analysis
  </label>

  <label style={{ marginLeft: "50px" }}>
    <input
      type="checkbox"
      className="mr-3"
      checked={isNeedAdditionalPointsChecked}
      onChange={(e) => setIsNeedAdditionalPointsChecked(e.target.checked)}
    />
  Necessary Improvements
  </label>
</div>

    <button onClick={analyzeResumesAndCertifications} 
    className="btn btn-primary mt-3"
    disabled={isComparing}
>
  {isComparing ? "Comparing..." : "Compare"}
    </button>

  <h4 style={{color:"#00a7ac",marginTop: "20px" }}>Comparison Results</h4>  
   <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
  {/* {selectedCards.length > 0 && (
    <button className="btn btn-primary" onClick={handleSubmitTest}>
      Configure Test
    </button>
  )} */}
</div>
    <div>
    {showDetails && resumeText.length > 0 ? (
         <div> {/* Ensure there's a single parent wrapper */}
         {[...resumeText]
       .sort((a, b) => b.matchedSkillsPercentage - a.matchedSkillsPercentage)
         .map((resume, index) => {
           // const isSelected = selectedCards.find((card) => card.candidateID == resume.candidateID) !== undefined;
     
           return (  
              <div style={{ marginTop: "20px", width: "100%", padding: "15px", border: "1px solid #ccc", borderRadius: "8px" }}>
             {/* <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">select</Tooltip>}> */}
                    {/* {(resume.email !== 'Not Found' && resume.email !== 'N/A') && (
  <button
    className="btn btn-primary"
    style={{ float: 'right' }}
    onClick={() => handleSubmitTest(resume)}
  >
    Configure Test
  </button>
)} */}

             {/* </OverlayTrigger>   */}
               <p style={{ fontSize: "18px" }}><strong>File:</strong> {resume.fileName}</p>
           <p style={{ fontSize: "18px" }}><strong>Name:</strong> {resume?.name}</p>
           <p style={{ fontSize: "18px" }}><strong>Email:</strong>{resume?.email}</p>
           <p style={{ fontSize: "18px" }}><strong>Phone Number:</strong>{resume?.phoneNumber}</p>
           <p style={{ fontSize: "18px" }}><strong>Profile Summary:</strong>{resume?.profilesummary}</p>
           <p style={{ fontSize: "18px" }}><strong>Experience:</strong>{resume?.experience}</p>
           <p style={{ fontSize: "18px" }}><strong>Address:</strong>{resume?.address}</p>
           <p style={{ fontSize: "18px" }}><strong>Linkedin URL:</strong>{resume?.linkedin}</p>

             <p style={{ fontSize: "18px" }}><strong>Resume Skills:</strong>{resume?.skills?.length > 0 ? resume?.skills?.sort((a, b) => a.localeCompare(b)).join(", ")  : "Not Found"}</p>  
           <p style={{ fontSize: "18px" }}><strong>JD Skills:</strong>{extractedTextSkills.length > 0 ? extractedTextSkills?.sort((a, b) => a.localeCompare(b)).join(", ") : "Not Found"}</p>
           <p style={{fontSize:18, fontWeight: "bold", color:"#00a7ac"}}><strong>Matched Skills:</strong>{resume.matchedSkills?.length > 0 ? resume?.matchedSkills?.sort((a, b) => a.localeCompare(b)).join(", ")  : "Not Found"}</p> 
           <p style={{fontSize:18, fontWeight: "bold", color:"red"}}><strong>UnMatched Skills:</strong>{resume.unmatchedSkills?.length > 0 ? resume.unmatchedSkills?.sort((a, b) => a.localeCompare(b)).join(", ")  : "Not Found"}</p> 
     
           <p style={{ fontSize: "18px", color:"#00a7ac" }}>  <i className="fas fa-chart-line" style={{ marginRight: 10 }}></i><strong>Matched Skills Percentage:{resume.matchedSkillsPercentage}%</strong></p>
           <p style={{ fontSize: "18px" }}><strong>Candidates Certifications:</strong>{ <ul>
             {resume?.certifications?.map((cert, index) => (
               <li key={index}>{cert}</li>
             ))}
           </ul>}</p>
           <p style={{ fontSize: "18px" }}><strong>Matched Certifications with Job Responsibilities:</strong>{ <ul>
             {resume?.matchedCertificationswithJobResponsibilities?.map((cert, index) => (
               <li key={index}>{cert}</li>
             ))}
           </ul>}</p>
           {/* <p style={{ fontSize: "18px", color:"#00a7ac" }}><i className="fas fa-chart-line" style={{ marginRight: 10 }}></i><strong>Matched Key Responsibilities Percentage:{resume.matchJobResponsibilitiesPercentage}</strong></p> */}
           <p style={{ fontSize: "18px"}}><strong style={{color:"#00a7ac",fontWeight: "bold",}}>Additional Insights:</strong>{ <ul>
             {resume?.reasons?.map((reason, index) => (
               <li key={index}>{reason}</li>
             ))}
           </ul>}</p>
                  {isGapAnalysisChecked &&
            <p style={{ fontSize: "18px" }}>
  { resume?.timeGaps?.length > 0 ? (
      <><strong style={{ color: "#00a7ac", fontWeight: "bold" }}>Career Gaps:</strong><ul>
                      {resume.timeGaps.map((gap, index) => (
                        <li key={index}>{gap}</li>
                      ))}
                    </ul></>
  ) : (
    <span> No significant gaps found.</span>
  )}
</p>
          }

  {isNeedAdditionalPointsChecked &&<p style={{ fontSize: "18px" }}>
 
 {resume?.necessaryImprovements?.length > 0  ? (
     <><strong style={{ color: "#00a7ac", fontWeight: "bold" }}>Necessary Improvements:</strong><ul>
                      {resume.necessaryImprovements.map((point, index) => (
                        <li key={index}>{point}</li>
                      ))}
                    </ul></>
  ) : (
    <span> No improvement points detected.</span>
  )}
</p>
          }
           </div>
           )
     })}</div>) : (
             <p>No comparison done yet.</p>
           )
        }
  </div>
  </>)}
   <Modal show={showModal} onHide={handleClose}centered>
      <Modal.Header closeButton ></Modal.Header>
      <Modal.Body style={{ padding: 0}}>
      {isLoading? <LoadingSpinner/> :  
      <div className="card p-4 shadow mt-2 mb-2" style={{ width: "380px",margin:"auto"}}>
          <h3 className="text-center">{isLogin ? "Login" : "Create an Account"}</h3>

          {/* {!isLogin && (
            <>
              <button className="btn btn-primary w-100 mb-2" style={{ backgroundColor: "#00a7ac", border: "none", borderRadius: 15 }}>
                <i className="fa fa-google me-2"></i> Sign up with Google
              </button>
              <button className="btn btn-primary w-100 mb-2" style={{ backgroundColor: "#00a7ac", border: "none", borderRadius: 15 }}>
                <i className="fa fa-envelope me-2"></i> Sign up with Microsoft Outlook
              </button>
              <div className="text-center my-2">or</div>
            </>
          )} */}

          {/* Login/Register Form */}
          <form onSubmit={handleSubmit(isLogin ? handleLogin : handleRegister)}>
       {!isLogin &&  <><div className="mb-3">
                  <input
                    type="text"
                    placeholder="Enter Full Name"
                    {...register("FirstName", { required: "Full Name is required" })}
                    className={`form-control ${errors.FirstName ? "is-invalid" : ""}`} />
                  <div className="invalid-feedback">{errors.FirstName?.message}</div>
                </div>
                <div className="mt-3 mb-3">
                    <Controller
                      name="CountryMappings"
                      control={control}
                      rules={{ required: "At least one Staffing Type must be selected" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={[
                            { value: "1", label: "India Staffing" },
                            { value: "2", label: "US Staffing" }
                          ]}
                         placeholder=" Select Staffing Type"
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              minHeight: 50,
                              borderRadius: 15,
                              borderColor: errors.CountryMappings ? 'red' : provided.borderColor,
                            }),
                            placeholder: (provided) => ({
                              ...provided,
                              fontSize: '12px', // 👈 Smaller font size
                              color: '#999', // Optional: lighter color for placeholder
                            }),
                            menu: (provided) => ({
                              ...provided,
                              fontSize: '12px',
                            }),
                            option: (provided) => ({
                              ...provided,
                              fontSize: '12px',
                            }),
                          }}
                          className={` basic-form ${errors.CountryMappings ? 'is-invalid' : ''}`}
                          onChange={(selectedOptions) => {
                            field.onChange(selectedOptions);
                          } } />
                      )} />
                    {errors.CountryMappings && (
                      <div className="invalid-feedback d-block">{errors.CountryMappings.message}</div>
                    )}
                  </div></>
            }
            <div className="mb-3">
              <input
                type="email"
                placeholder="Enter email (work email)"
                {...register("email", { required: "Email is required" })}
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
              />
              <div className="invalid-feedback">{errors.email?.message}</div>
            </div>

            <div className="mb-3 position-relative">
            <input
                type={showPassword ? "text" : "password"}
                placeholder={isLogin ? "Enter password" : "Create password"}
                {...register("password", { required: "Password is required" })}
                className={`form-control ${errors.password ? "is-invalid" : ""}`}
            />
            <div className="invalid-feedback">{errors.password?.message}</div>

            {/* Eye Icon Button */}
            <span
                className="position-absolute end-0 top-50 translate-middle-y me-3"
                style={{ cursor: "pointer" }}
                onClick={() => setShowPassword(!showPassword)}
            >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </span>
        </div>

            <button
              type="submit"
              disabled={isLoading}
              className="btn btn-primary w-100"
              style={{ backgroundColor: "#00a7ac", border: "none", borderRadius: 15 }}
            >
              {isLoading ? "Processing..." : isLogin ? "Login" : "Create Account"}
            </button>
          </form>

          <p className="text-center mt-3">
            {isLogin ? "Don't have an account? " : "Already have an account? "}
            <span
              style={{ cursor: "pointer", color: "#00a7ac", textDecoration: "underline" }}
              onClick={() => setIsLogin(!isLogin)}
            >
              {isLogin ? "Sign Up" : "Log In"}
            </span>
          </p>

          <p className="text-center mt-2">
            Contact: <a href="mailto:hire@knackhook.com">hire@knackhook.com</a>
          </p>
        </div>
         }
      </Modal.Body>

    </Modal>
 
    <Modal show={isModalOpen}  onHide={onClose} centered>
      <Modal.Header closeButton>Configure Test</Modal.Header>
   {isLoading ? <LoadingSpinner/> :   <Modal.Body style={{ padding: 20 }}>
     
        {step === 1 && ( 
  <div>
  <div className="form-group" style={{ width: '100%' }}>
      <label style={{color:"#00a7ac"}}>Job Role</label>
      <Controller
      name="jobRoleID"
      control={control}
      rules={{ required: "Job Role is required" }}
      render={({ field }) => (
        <Select
          {...field}
           placeholder="Select Job Role"
          options={jobRoleOptions}
          value={jobRoleOptions.find(option => option.value === formData.jobRoleID) || null} 
         onChange={(selectedOption) => {
        setFormData({ ...formData, jobRoleID: selectedOption?.value }); // Corrected onChange
        field.onChange(selectedOption); // Updates react-hook-form
      }}        
        className={`basic-form ${errors.JobRole ? 'is-invalid' : ''}`}
          styles={{
            control: (provided, state) => ({
              ...provided,
              height: 50,
              borderRadius: 15,
              borderColor: errors.JobRole ? 'red' : provided.borderColor
            }),
            menu: (provided) => ({
              ...provided,
              zIndex: 9999, // Ensures dropdown appears above everything
              position: "absolute" // Fixes layout issues
            })
          }}
        />
      )}
    />
  
    </div>
    <div className="form-group">
      <label style={{color:"#00a7ac"}}>Start Date</label>
      <input
        type="date"
        className="form-control"
        value={formData.startDate}
        onChange={(e) => setFormData({ ...formData, startDate: e.target.value })}
      />
    </div>

    <div className="form-group">
      <label style={{color:"#00a7ac"}}>End Date</label>
      <input
        type="date"
        className="form-control"
        value={formData.endDate}
        onChange={(e) => setFormData({ ...formData, endDate: e.target.value })}
      />
    </div>

    <div className="form-group">
      <label style={{color:"#00a7ac"}}>Questions Count</label>
      <select
        className="form-control"
        value={formData.questionCount}
        onChange={(e) => setFormData({ ...formData, questionCount: e.target.value })}
        style={{ height: 50, borderRadius: 15 }}
      >
        <option value="">Select Number of Questions</option>
        {questions.map((item, index) => (
          <option key={index} value={item.questionValue}>
            {item.questionValue}
          </option>
        ))}
      </select>
    </div>

    <div className="form-group">
      <label style={{color:"#00a7ac"}}>Duration</label>
      <select
        className="form-control"
        value={formData.duration}
        onChange={(e) => setFormData({ ...formData, duration: e.target.value })}
        style={{ height: 50, borderRadius: 15 }}
      >
        <option value="">Select Time Duration(in mins)</option>
        {duration.map((item, index) => (
          <option key={index} value={item.durationValue}>
            {item.durationValue}
          </option>
        ))}
      </select>
    </div>


<div className="form-group">
  <label className="mt-3 mr-3" style={{ color: "#00a7ac" }}>
    Video Required
  </label>

  <input
    type="radio"
    name="isVideoRequired"
    value="True"
    id="field-true"
    checked={formData.isVideoRequired === true}
    onChange={() => setFormData({ ...formData, isVideoRequired: true })}
  />
  <label style={{ fontSize: 13, color: "#495057", marginRight: 24, marginLeft: 6 }}>
   Yes
  </label>

  <input
    type="radio"
    name="isVideoRequired"
    value="False"
    id="field-false"
    checked={formData.isVideoRequired === false}
    onChange={() => setFormData({ ...formData, isVideoRequired: false })}
  />
  <label style={{ fontSize: 13, color: "#495057", marginLeft: 6 }}>
  No
  </label>

  {errors.isVideoRequired && (
    <div style={{ color: "#dc3545", fontSize: "80%" }}>Select Yes or No</div>
  )}
</div>

<div className="d-flex" style={{float:'right'}}>
    <button className="btn btn-primary mr-3" onClick={handleProceed}>
      Proceed
    </button>
    <button className="btn btn-secondary" onClick={onClose}>
          Close
        </button>
        </div>
  </div>
       )}
        {/* Step 2: Candidate List */}
        {step === 2 && (
        
        <div>
           
            {selectedCards.length > 0 ? (
              <ul>
                {selectedCards.map((candidate) => (
                  <li key={candidate.candidateID} className="candidate-item">
                    {candidate.name} - {candidate.email}
                    <button style={{ background: "none", border: "none",float:'right' }} onClick={() => handleRemoveCandidate(candidate.candidateID)}>
                    <i className="fa fa-trash" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>
                    </button>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No candidates selected.</p>
            )}
            <div className="d-flex mt-5" style={{float:'right'}}>

            <button className="btn btn-primary mr-3" onClick={handleConfigureTest} disabled={selectedCards.length === 0}>
              Configure Test
            </button>
            <button className="btn btn-primary" onClick={onClose}>
          Close
        </button>
        </div>
          </div>
        )}
      </Modal.Body>
          }
      
    </Modal>
    </div>
  )}



export default AIResumeInsights;